import actions from 'react/api/actions';
import { Map } from 'immutable';

const { features: { actions: { setFeature } } } = actions;

const initialState = Map({});

export default (state = initialState, action) => {
  switch (action.type) {
    case setFeature: {
      const { featureStates } = action.payload;

      featureStates.forEach((item) => {
        const { name, enabled, parameters } = item;

        // For each new Feature we have to set the menus it should hide
        if (name === 'PROACTIVE_ROUTE_OPTIMIZATION') {
          state = state.set(name, {
            enabled,
            menusNames: ['topMenu.proactiveRouteOptConfig']
          });
        } else if (name === 'ENABLE_TICKET_SUPPORT') {
          state = state.set(name, {
            enabled,
            menusNames: ['Ticket.title']
          });
        } else if (name === 'ARCHIVE_PROCESSOR') {
          state = state.set(name, {
            enabled,
            menusNames: ['topMenu.dataSync']
          });
        } else {
          state = state.set(name, {
            enabled,
            parameters
          });
        }
      });

      return state;
    }
    default:
      return state;
  }
};
